<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                labClientOrganisationForm: () => import('../forms/LabClientOrganisationForm'),
                fields: [
                    { type: 'autocomplete', text: 'Lab Client Organisation', value: 'labClientOrganisationId', rules: [v => !!v || 'Lab Client Organisation is required'], isRequired: true, form: () => import('./LabClientOrganisationForm'), apiMethod: 'LabClientOrganisations', claim: 'LabClientOrganisations' },
                    { type: 'datetime', text: 'Samples To Be Mailed On', value: 'samplesToBeMailedOn', rules: [v => !!v || 'Samples To Be Mailed On is required'], isRequired: true },
                    { type: 'datetime', text: 'Completed On', value: 'completedOn', rules: [] },
                ],
                apiMethod: 'SampleSets',
                formTitle: 'Sample Set',
            }
        },
    };
</script>
